// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddJob_modal__MYT9I","buttons":"AddJob_buttons__1Uv8C","button":"AddJob_button__3V24y"};